import { LocalStorageInterface } from "etl/core";

export const browserLocalStorage: LocalStorageInterface = {
	setItem(key, value) {
		localStorage.setItem(key, value);
	},

	async getItem(key) {
		return localStorage.getItem(key)
	},

	removeItem(key) {
		localStorage.removeItem(key)
	},

	clear() {
		localStorage.clear()
	}
}
